var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M6.875 18.003c-1.864 0-3.375-1.166-3.375-2.877 0-1.71 1.511-3.096 3.375-3.096.127 0 .252.006.375.018v-.018h.046a5.108 5.108 0 0 1-.046-.689c0-3.04 2.686-5.505 6-5.505 2.244 0 4.2 1.13 5.23 2.804a5.76 5.76 0 0 1 .77-.051c2.9 0 5.25 2.156 5.25 4.817 0 2.19-1.593 3.86-3.773 4.41m-6.893 4.353v-7.903m-3.447 4.644 3.447 3.26 3.444-3.26"
  })));
};
export default SvgDownload;